import React, { Component } from 'react';
import * as THREE from 'three';

class CSS3DWorld extends Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      fovValue: 0,
    };
  }

  componentDidMount() {}

  componentWillReceiveProps(nextProps) {
    this.setState({
      fovValue:
        0.5 / Math.tan(THREE.Math.degToRad(nextProps.cameraFov * 0.5)) * nextProps.windowHeight,
    });
  }

  render() {
    const divStyle = {
      position: 'absolute',
      top: '0',
      left: '0',
      width: '100%',
      height: '100%',

      WebkitPerspective: `${this.state.fovValue}px`,
      WebkitPerspectiveOrigin: '50% 50%',

      MozPerspective: `${this.state.fovValue}px`,
      MozPerspectiveOrigin: '50% 50%',

      perspective: `${this.state.fovValue}px`,
      perspectiveOrigin: '50% 50%',

      OPerspective: `${this.state.fovValue}px`,
      OPerspectiveOrigin: '50% 50%',
    };
    return (
      <div className="css-world" style={divStyle}>
        {this.props.children}
      </div>
    );
  }
}

export default CSS3DWorld;



// WEBPACK FOOTER //
// ./src/components/Player/CSS3DWorld/CSS3DWorld.js